import { isSmallSize } from '@sm/WindowSizes';

export const HOMEPAGE_SCROLL_CONTAINER_ID = 'homepage-scroll-container';
export const PRICING_ANCHOR = 'pricing';
export const FEATURES_ANCHOR = 'features';
export const ALLOWED_SCROLL_HASHES = [FEATURES_ANCHOR, PRICING_ANCHOR];
export const HEADER_HEIGHT = isSmallSize() ? '68px' : '6rem';
